import { Component, computed, EventEmitter, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { Yard } from 'src/app/services/app/yard.service';


@Component({
  selector: 'assign-form',
  templateUrl: './assign-form.component.html',
  styleUrls: ['./assign-form.component.css'],
})
export class AssignFormComponent implements OnChanges {
  /**
   *  getting in all the open yard spots for the dropdown menu.
   * There is no need to modify this list as it is getting fed in by the
   * parent component and gets modified there. The targetStartYard is also
   * being feed in to determine the starting position. The end position gets fed to
   * throught the reserveSpot method where it then gets combined with the starting
   * position and emmited back to the parent component.
   */
  @Output() targetEndYard: EventEmitter<number> = new EventEmitter();
  @Input() openYardSpots: Yard[];
  @Input() targetStartYard: Yard;
  selectedIndex = signal<number | null>(null);
  openYards = signal<Yard[]>([]);


  canSubmit = computed(() => {
    return this.selectedIndex() >= 0 && typeof this.selectedIndex() === 'number';
  });

  constructor() { }


  // The handler method
  onSelectChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;

    // Convert string to number (since HTML values are always strings)
    // If value is empty string, set to null
    if (value === '' || value === 'null') {
      this.selectedIndex.set(null);
    } else {
      this.selectedIndex.set(parseInt(value));
    }
  }


  reserveSpot() {
    /* the initial value of the dropdown will display nothing and
    resive an undefined selectedEndYard value for this reason the targetMove
    will only emit if there is a value selected
    */
    if (!this.canSubmit()) {
      return;
    }


    this.targetEndYard.emit(this.selectedIndex());
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.openYardSpots) {
      this.openYardSpots = changes.openYardSpots.currentValue;
      this.openYards.set(this.openYardSpots);
    }

  }
}
